import { useCallback, useMemo } from 'react';
import { useProviderTitleLocalization } from './use-provider-title-localization';
export const useDisplayName = (user) => {
    const titleLocalization = useProviderTitleLocalization();
    return useMemo(() => {
        if (!user.id)
            return;
        if (user.displayName) {
            return user.displayName;
        }
        const title = user.title !== ''
            ? `${titleLocalization(user.title)} `
            : '';
        return `${title}${user.lastName}`;
    }, [user]);
};
export const useProviderFullNameBuilder = () => {
    const titleLocalization = useProviderTitleLocalization();
    return useCallback((user) => {
        const title = user.title !== ''
            ? titleLocalization(user.title)
            : '';
        return [title, user.firstName, user.lastName]
            .filter((text) => !!text)
            .join(' ');
    }, [titleLocalization]);
};
